import { setBaseUrl } from "@workspace/api-client-react";

// In Replit, the API server is accessible at /api through the proxy.
// No base URL override needed for web apps running behind the Replit proxy.
setBaseUrl(null);
